import { Field } from 'redux-form';
import { DatePickerLeisure, InfoButton } from '../../../../common/components';
import React from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { addDays, subDays } from 'date-fns';
import { hasPermission } from '../../../auth/redux/authActions';
import { required } from 'redux-form-validators';

const AnnualDatePicker = ({ isExpired, requireStartDate, isDisabled }) => {
  if (isExpired) {
    return (
      <Field
        name="data.attributes.metadata.start_date"
        component={DatePickerLeisure}
        validate={requireStartDate && required({ msg: 'Start date is required' })}
      />
    );
  }

  const maxDate = addDays(new Date(), 90);
  const canBackdateCover = hasPermission('policy.backdate_cover');
  const minStartDate = canBackdateCover ? subDays(new Date(), 30) : new Date();

  return (
    <Field
      name="data.attributes.metadata.start_date"
      maxDate={maxDate}
      minDate={minStartDate}
      component={DatePickerLeisure}
      isDisabled={isDisabled}
      validate={requireStartDate && required({ msg: 'Start date is required' })}
    />
  );
};

const AnnualDates = ({ show, dateDefinition, isExpired, requireStartDate, isMta }) => {
  if (!show) {
    return null;
  }

  const isDisabled = isMta && !hasPermission('policy.edit-mta-amt-start-date');
  return (
    <FormGroup>
      <Col sm={4}>
        <ControlLabel>
          When would you like your annual policy to start?{' '}
          <InfoButton content={dateDefinition} />
        </ControlLabel>
      </Col>
      <Col sm={8}>
        <div className={'travel-dates'}>
          <AnnualDatePicker
            isExpired={isExpired}
            requireStartDate={requireStartDate}
            isDisabled={isDisabled}
          />
        </div>
      </Col>
    </FormGroup>
  );
};
export default AnnualDates;
